var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _path13, _path14, _path15, _rect, _path16, _rect2, _path17, _rect3, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _rect4, _rect5, _rect6, _path54, _path55, _path56, _path57, _path58, _path59;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrunck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 94,
    viewBox: "0 0 175 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.283 69.4181L144.849 81.7181H171.859V49.7382L162.253 26.4583L127.283 24.6207V69.4181Z",
    fill: "#C8D6DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.283 22.6854H160.652L162.262 26.4669H127.283V22.6854Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.629 77.5195H172.66V84.8793H156.629V77.5195Z",
    fill: "#C8D6DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.52 52.0403H147.376V54.3245H140.52V52.0403Z",
    fill: "#909B9F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29793 65.3199L63.9424 65.3236L70.1672 74.0156H4.08057L9.29793 65.3199Z",
    fill: "#2A2B2C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M171.599 45.2641H172.66C173.62 45.2641 174.399 44.4821 174.399 43.5219V36.5703C174.399 35.6072 173.62 34.8281 172.66 34.8281H171.464V39.0945L165.087 44.6604L165.467 45.1319L171.464 39.8678V44.5942L167.298 48.3374C167.229 48.3921 167.189 48.4725 167.183 48.553C167.177 48.6249 167.2 48.6997 167.249 48.7629C167.353 48.8923 167.543 48.9153 167.675 48.8118L171.599 45.2641Z",
    fill: "#909B9F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.102 77.5195H162.518L164.726 84.8793H160.31L158.102 77.5195Z",
    fill: "#C8D6DC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.462 77.5195H169.878L172.086 84.8793H167.67L165.462 77.5195Z",
    fill: "#C8D6DC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140.515 45.6142L140.554 30.2579H159.506L169.822 49.1655L140.515 45.6142Z",
    fill: "#909B9F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.053 32.1444L141.355 38.7621V44.4344L148.891 45.3797L158.101 32.1444H148.053Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M160.613 34.9806L153.915 46.3251L163.125 47.2705L164.8 42.5436L160.613 34.9806Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.534 53.9858C117.689 52.8533 114.833 51.0475 114.833 51.0475L114.048 55.393L118.527 58.0169L114.833 72.7912H125.411V57.5118C125.411 57.5118 121.815 55.3858 119.534 53.9858Z",
    fill: "#C8D6DC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121.886,
    cy: 59.8623,
    r: 1.17534,
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6228 10.0345L66.158 6.20238L94.4376 13.8936L94.4374 13.8944L104.47 16.6229L124.547 32.8601L115.615 65.7009L90.0798 69.533L61.8002 61.8419L61.8005 61.8411L51.7681 59.1126L31.6911 42.8753L40.6228 10.0345Z",
    fill: "#C8D6DC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4213 32.8392L31.6922 42.8739L51.7692 59.1111L90.0834 69.5314L115.619 65.6993L118.348 55.6646L34.4213 32.8392Z",
    fill: "#C8D6DC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5713 10.1004L40.4274 6.18714L30.532 42.6847L21.4076 40.2109L29.5713 10.1004Z",
    fill: "#C8D6DC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.9205,
    y: 4.36334,
    width: 3.78152,
    height: 39.706,
    transform: "rotate(15.1696 40.9205 4.36334)",
    fill: "#C8D6DC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2028 44.4335L17.6229 37.8158L17.6229 62.3957H42.2028V44.4335Z",
    fill: "#C8D6DC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9934,
    y: 47.2668,
    width: 14.7479,
    height: 3.78152,
    fill: "#C8D6DC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7413 47.2668H24.9934V49.1575H37.2834V51.0483H39.7413V47.2668Z",
    fill: "#5F6465"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9934,
    y: 52.936,
    width: 14.7479,
    height: 7.56305,
    fill: "#C8D6DC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7413 52.936H24.9934V56.1128H37.2834V60.4991H39.7413V52.936Z",
    fill: "#5F6465"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9666 35.7695H27.0695V31.988H12.9666C11.3582 31.988 10.0527 32.8344 10.0527 33.8783C10.0527 34.9222 11.3582 35.7695 12.9666 35.7695Z",
    fill: "#C8D6DC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0345 54.3591H39.9919V50.8521H13.0345C11.4599 50.8521 10.1819 51.637 10.1819 52.606C10.1819 53.5741 11.4599 54.3591 13.0345 54.3591Z",
    fill: "#C8D6DC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7734 22.6894H22.6402V62.8093H23.7734V22.6894Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1243 22.6894H13.9911V62.8093H15.1243V22.6894Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2024 23.8164H14.5522V24.631H23.2024V23.8164Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2024 29.9958H14.5522V30.8103H23.2024V29.9958Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2024 36.1684H14.5522V36.9829H23.2024V36.1684Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2024 42.3411H14.5522V43.1557H23.2024V42.3411Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2024 48.5172H14.5522V49.3317H23.2024V48.5172Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2024 54.6882H14.5522V55.5027H23.2024V54.6882Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2024 60.8682H14.5522V61.6828H23.2024V60.8682Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1685 62.3901H65.3675L71.747 71.222H136.022V75.6379H70.5194L64.1399 66.8061H11.3961L5.01662 75.6379H0.600708L10.1685 62.3901Z",
    fill: "#C8D6DC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2652 62.3904H12.3773V66.8063H18.2652V62.3904Z",
    fill: "#C8D6DC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2091 62.3904H27.097V66.8063H21.2091V62.3904Z",
    fill: "#C8D6DC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9289 62.3904H30.041V66.8063H35.9289V62.3904Z",
    fill: "#C8D6DC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8728 62.3904H44.7607V66.8063H38.8728V62.3904Z",
    fill: "#C8D6DC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5925 62.3904H47.7046V66.8063H53.5925V62.3904Z",
    fill: "#C8D6DC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5365 62.3904H62.4243V66.8063H56.5365V62.3904Z",
    fill: "#C8D6DC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0319 71.2222H77.1441V75.6381H83.0319V71.2222Z",
    fill: "#C8D6DC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9759 71.2222H91.8638V75.6381H85.9759V71.2222Z",
    fill: "#C8D6DC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M100.696 71.2222H94.8077V75.6381H100.696V71.2222Z",
    fill: "#C8D6DC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M103.64 71.2222H109.527V75.6381H103.64V71.2222Z",
    fill: "#C8D6DC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M118.359 71.2222H112.471V75.6381H118.359V71.2222Z",
    fill: "#C8D6DC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M121.303 71.2222H129.082V75.6381H121.303V71.2222Z",
    fill: "#C8D6DC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M130.135 71.2222H136.023V75.6381H130.135V71.2222Z",
    fill: "#C8D6DC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M127.283 66.1752H151.863V66.2416C152.173 66.1973 152.487 66.1752 152.808 66.1752C156.143 66.1752 158.902 68.6383 159.36 71.8475H172.661V77.5197H155.645V75.629H127.283V66.1752Z",
    fill: "#909B9F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M144.93 93.2844C137.963 93.2844 132.325 87.6415 132.325 80.6798C132.325 73.718 137.963 68.0742 144.93 68.0742C151.888 68.0742 157.535 73.718 157.535 80.6798C157.535 87.6415 151.888 93.2844 144.93 93.2844Z",
    fill: "#5F6465"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M144.932 87.4724C141.179 87.4724 138.139 84.4335 138.139 80.6856C138.139 76.9366 141.179 73.8977 144.932 73.8977C148.673 73.8977 151.713 76.9366 151.713 80.6856C151.713 84.4335 148.673 87.4724 144.932 87.4724Z",
    fill: "#C8D6DC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M144.927 83.5921C143.318 83.5921 142.016 82.2897 142.016 80.6834C142.016 79.0767 143.318 77.7744 144.927 77.7744C146.53 77.7744 147.833 79.0767 147.833 80.6834C147.833 82.2897 146.53 83.5921 144.927 83.5921Z",
    fill: "#5F6465"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9096 93.2844C45.9419 93.2844 40.3046 87.6415 40.3046 80.6798C40.3046 73.718 45.9419 68.0742 52.9096 68.0742C59.8678 68.0742 65.5148 73.718 65.5148 80.6798C65.5148 87.6415 59.8678 93.2844 52.9096 93.2844Z",
    fill: "#5F6465"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9168 87.4724C49.164 87.4724 46.124 84.4335 46.124 80.6856C46.124 76.9366 49.164 73.8977 52.9168 73.8977C56.6585 73.8977 59.6987 76.9366 59.6987 80.6856C59.6987 84.4335 56.6585 87.4724 52.9168 87.4724Z",
    fill: "#C8D6DC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M52.912 83.5921C51.3036 83.5921 50.0007 82.2897 50.0007 80.6834C50.0007 79.0767 51.3036 77.7744 52.912 77.7744C54.5155 77.7744 55.8185 79.0767 55.8185 80.6834C55.8185 82.2897 54.5155 83.5921 52.912 83.5921Z",
    fill: "#5F6465"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5506 93.2844C17.5828 93.2844 11.9456 87.6415 11.9456 80.6798C11.9456 73.718 17.5828 68.0742 24.5506 68.0742C31.5087 68.0742 37.1557 73.718 37.1557 80.6798C37.1557 87.6415 31.5087 93.2844 24.5506 93.2844Z",
    fill: "#5F6465"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M24.561 87.4715C20.8083 87.4715 17.7682 84.4327 17.7682 80.6847C17.7682 76.9357 20.8083 73.8969 24.561 73.8969C28.3027 73.8969 31.3429 76.9357 31.3429 80.6847C31.3429 84.4327 28.3027 87.4715 24.561 87.4715Z",
    fill: "#C8D6DC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5545 83.592C22.9462 83.592 21.6433 82.2896 21.6433 80.6833C21.6433 79.0766 22.9462 77.7742 24.5545 77.7742C26.1581 77.7742 27.461 79.0766 27.461 80.6833C27.461 82.2896 26.1581 83.592 24.5545 83.592Z",
    fill: "#5F6465"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 136.739,
    y: 26.4696,
    width: 1.89076,
    height: 39.706,
    fill: "#909B9F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 129.674,
    y: 30.7497,
    width: 4.67228,
    height: 14.1261,
    fill: "#C8D6DC",
    stroke: "#909B9F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 168.881,
    y: 64.2835,
    width: 3.78152,
    height: 5.67228,
    fill: "#909B9F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5406 48.7331C97.5406 48.7331 97.546 48.7237 97.5477 48.7185L100.343 39.7832C100.385 39.6494 100.311 39.5075 100.178 39.4659L97.966 38.7738C97.8331 38.7322 97.6911 38.8065 97.6493 38.9403L95.9428 44.3945L93.2813 37.7008C93.1808 37.4611 93.1436 37.2635 92.8508 37.1719L90.0824 36.3057C89.9247 36.2564 89.761 36.3449 89.7124 36.5003L86.9294 45.395C86.8876 45.5286 86.9619 45.6705 87.0948 45.7121L89.2415 46.3838C89.3744 46.4254 89.5163 46.3511 89.5581 46.2175L91.3212 40.5825L94.1087 47.324C94.2721 47.7105 94.3316 47.9947 94.7326 48.1201L97.2757 48.9158C97.3568 48.9412 97.4418 48.8909 97.5001 48.8072C97.5035 48.8041 97.5056 48.7976 97.509 48.7945C97.5226 48.7749 97.5316 48.754 97.541 48.732",
    fill: "#BB5E00"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8547 30.528L62.1821 27.5017C62.0492 27.4601 61.9073 27.5344 61.8655 27.668L61.1761 29.8714C61.1343 30.005 61.2085 30.147 61.3414 30.1885L64.8307 31.2803L62.8999 37.4512C62.7323 37.9871 62.8058 38.1315 62.9432 38.1745L65.1484 38.8645C65.2836 38.9068 65.4282 38.8321 65.5963 38.2948L67.527 32.1239L71.014 33.2149C71.1492 33.2572 71.2911 33.1829 71.3329 33.0493L72.0223 30.8458C72.0641 30.7123 71.9898 30.5703 71.8547 30.528Z",
    fill: "#BB5E00"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9017 34.997L83.4846 34.2408C83.3517 34.1992 83.1934 34.3258 83.1313 34.5244L81.4244 39.9797C81.2563 40.517 80.8921 40.6614 80.534 40.5494L76.8352 39.3921C76.477 39.28 76.2634 38.959 76.422 38.4286L78.1328 32.9605C78.195 32.7618 78.1393 32.5683 78.0064 32.5267L75.5871 31.7698C75.4565 31.7289 75.2981 31.8555 75.236 32.0542L73.659 37.0945L73.4148 37.8985C72.7171 40.1286 73.6098 41.5119 75.0988 41.9778L80.4937 43.6657C81.9826 44.1316 83.5047 43.5038 84.2024 41.2738L86.0303 35.4315C86.0925 35.2328 86.0368 35.0393 85.9039 34.9977",
    fill: "#BB5E00"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M114.34 45.8896L114.837 44.3024C114.921 44.0337 114.845 43.771 114.664 43.7146L106.42 41.1351C105.476 40.8398 104.989 40.8634 104.514 41.0769C103.981 41.3169 103.559 41.9239 103.26 42.8813L101.765 47.6569C101.466 48.6141 101.467 49.3536 101.768 49.8545C102.036 50.3004 102.423 50.5975 103.367 50.8928L110.044 52.9818C110.987 53.2771 111.472 53.2527 111.947 53.0395C112.48 52.7993 112.904 52.193 113.204 51.2358L114.085 48.419C114.207 48.0282 114.088 47.6429 113.82 47.559L108.069 45.7597C107.934 45.7174 107.774 45.8432 107.712 46.0406L107.215 47.6277C107.153 47.8251 107.214 48.02 107.349 48.0623L111.156 49.2534C111.246 49.2815 111.283 49.4079 111.243 49.5363L111.039 50.1882C110.999 50.3166 110.896 50.4004 110.806 50.3722L104.757 48.4799C104.496 48.3981 104.381 48.0226 104.5 47.6421L105.474 44.5286C105.594 44.1468 105.902 43.9049 106.163 43.9867L113.829 46.385C114.007 46.4407 114.256 46.1581 114.34 45.8896Z",
    fill: "#BB5E00"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7715 23.3814L46.7059 22.7352C46.3201 22.6088 46.1428 22.559 45.7117 22.8222L42.787 24.6449L41.425 21.481C41.2186 21.0183 41.0446 20.9581 40.6577 20.8428L38.5899 20.1958C38.2678 20.095 37.949 20.4578 38.0734 20.8112L40.5821 26.989L39.5901 30.1597C39.4224 30.6956 39.4959 30.84 39.6333 30.883L41.8386 31.573C41.9738 31.6153 42.1184 31.5404 42.2864 31.0033L43.284 27.8148L48.8474 24.1822C49.1484 23.9633 49.0936 23.4822 48.7715 23.3814Z",
    fill: "#BB5E00"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4141 36.0151L56.6151 26.2331C56.5242 25.7884 56.3478 25.7513 55.8478 25.5948L54.5863 25.2002C54.0885 25.0444 53.9202 24.9737 53.5921 25.2872L46.5385 32.2995C46.3593 32.4769 46.1735 32.9287 46.7434 33.107L48.2338 33.576C48.8 33.7505 48.9587 33.7094 49.5939 33.0388L50.4463 32.1877L55.2646 33.6952L55.4799 34.8804C55.6219 35.7941 55.7266 35.9177 56.2912 36.0971L57.7855 36.5618C58.3531 36.7395 58.4579 36.2623 58.4096 36.0137L58.4141 36.0151ZM52.438 30.1933L54.2932 28.3422L54.7604 30.9199L52.438 30.1933Z",
    fill: "#FF0002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrunck);
export default __webpack_public_path__ + "static/media/trunck.a1aee819d58699998d352c25a9a46d5f.svg";
export { ForwardRef as ReactComponent };